<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <div class="superadmin-dashboard-area edit-area">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="registered-product-item w-half">
                            <!-- <a href="#" @click.prevent="back()"  class="mb-3 inline-block"> <i class="fas fa-long-arrow-alt-left"></i> Back</a> -->

                            <!-- <router-link :to="{ name: 'SuperadminCustomers'}" class="mb-3 inline-block"><i class="fas fa-long-arrow-alt-left"></i> Back</router-link> -->

                            <h3 class="mb-4">Edit User</h3>

                            <loading v-if="loading" />

                            <ul v-else>
                                <li class="mb-3">
                                    <span class="semibold mb-2">User type</span>
                                    <strong class="text-capitalize display-role-not-editable">{{ form.role }}</strong>
                                    <p class="font-11 font-light">We cannot update role without specific reason. Please contact developer.</p>
                                </li>

                                <li v-if="form.role != 'customer'">
                                    <span class="semibold mb-2">Company</span>
                                    <span><input type="text" v-model="form.company" name="company" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold mb-2">First Name</span>
                                    <span><input type="text" v-model="form.fname" name="fname" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold mb-2">Last name</span>
                                    <span><input type="text" v-model="form.lname" name="lname" class="form-control" /></span>
                                </li>
                                <li>
                                    <span class="semibold mb-2">Email</span>
                                    <span
                                        ><input type="text" v-model="form.email" name="email" class="form-control" :disabled="!vg_user.email_access"
                                    /></span>
                                </li>

                                <li>
                                    <span class="semibold mb-2">Address</span>
                                    <em class="notice">( please select the address from suggestion )</em>
                                    <!-- <span><input type="text" v-model="form.address" name="address" class="form-control" /></span> -->
                                    <span>
                                        <gmap-autocomplete
                                            id="user_address_edit"
                                            autocomplete="nope"
                                            class="form-control"
                                            large
                                            name="address"
                                            placeholder="your address..."
                                            :select-first-on-enter="true"
                                            :componentRestrictions="{country: ['ZA']}"
                                            @place_changed="setPlace"
                                            @keyup="resetPlace"
                                        >
                                        </gmap-autocomplete>
                                    </span>

                                    <div class="address-display-map">
                                        <gmap-map
                                            v-if="form.addressDetail && form.addressDetail.lat && form.addressDetail.lng"
                                            :center="{lat: parseFloat(form.addressDetail.lat), lng: parseFloat(form.addressDetail.lng)}"
                                            :zoom="16"
                                            map-type-id="terrain"
                                            style="width: 100%; height: 100%"
                                        >
                                            <gmap-marker
                                                :key="index"
                                                v-for="(m, index) in markers"
                                                :position="m.position"
                                                :clickable="true"
                                                :draggable="true"
                                                @click="center = m.position"
                                            ></gmap-marker>
                                        </gmap-map>
                                    </div>
                                    <div class="address-info-wrap" v-if="form.address && form.addressDetail && form.addressDetail.province">
                                        <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                        <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                        <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                        <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                                    </div>
                                </li>

                                <li>
                                    <span class="semibold mb-2">Complex/Building + Unit</span>
                                    <span
                                        ><input type="text" v-model="form.complex_building_unit" name="complex_building_unit" class="form-control"
                                    /></span>
                                </li>

                                <!-- <li v-if="form.role == 'reseller'">
                                    <label>Website:</label>
                                    <span><input type="text" v-model="form.website" name="website" class="form-control"/></span>
                                </li> -->

                                <li v-if="form.role == 'reseller'">
                                    <div class="mb-3 mt-3">
                                        <div>
                                            <p class="mb-0"><span class="semibold">Has website?</span></p>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model.number="form.has_website"
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="haveWebsite"
                                                    id="website_yes"
                                                    value="1"
                                                />
                                                <label class="form-check-label" for="website_yes">Yes</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model.number="form.has_website"
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="haveWebsite"
                                                    id="website_no"
                                                    value="0"
                                                />
                                                <label class="form-check-label" for="website_no">No</label>
                                            </div>
                                        </div>
                                        <div v-if="form.has_website == 1" class="website-holder">
                                            <span class="website-prefix dark">https://</span>
                                            <input type="text" v-model="form.website" placeholder="eg: example.com" class="form-control" />
                                        </div>
                                    </div>
                                </li>

                                <li>
                                    <span class="semibold mb-2">Mobile</span>
                                    <span><input type="number" v-model="form.mobile" name="mobile" class="form-control" /></span>
                                </li>

                                <!-- <li>
                        Role:
                        <span><select v-model="form.role">
                          <option value="customer">Customer</option>
                          <option value="reseller">Reseller</option>
                          <option value="distributor">Distributor</option>
                          </select>
                        </span>
                      </li> -->

                                <li v-if="form.role == 'reseller'">
                                    <span class="semibold mb-2">Reseller Type</span>
                                    <select v-model="form.reseller_type" class="baseline-input">
                                        <option value="">--Select--</option>
                                        <option :value="resellerType.value" v-bind:key="resellerType.value" v-for="resellerType in resellerTypes">
                                            {{ resellerType.label }}
                                        </option>
                                    </select>
                                </li>

                                <li v-if="form.role == 'reseller'">
                                    <span class="semibold mb-2">Select Depo</span>
                                    <select v-model="form.distributor_id" class="baseline-input">
                                        <option value="">--Select--</option>
                                        <option
                                            :value="distributor.id"
                                            v-bind:key="distributor.company + distributor.id"
                                            v-for="distributor in distributors"
                                        >
                                            {{ distributor.company }}
                                        </option>
                                    </select>
                                </li>
                                <li v-if="form.role != 'customer'">
                                    <span class="semibold mb-2">Region</span>
                                    <select v-model="form.region" class="baseline-input">
                                        <option value="">--Select--</option>
                                        <option :value="region" v-bind:key="region" v-for="region in regions">{{ region }}</option>
                                    </select>
                                </li>

                                <li v-if="form.role == 'distributor'">
                                    <p>
                                        <span class="semibold mb-2">Depot Technician</span>
                                        <em style="font-size: 11px">Email address separated by "," comma</em>
                                        <input
                                            class="baseline-input"
                                            name="ccem"
                                            v-model="form.tech_emails"
                                            type="text"
                                            autocomplete="new-em"
                                            id="cc_em"
                                        />
                                    </p>
                                </li>

                                <li>
                                    <button class="btn btn-primary mt-3 px-5" @click.prevent="updateSuperadminCustomer()">UPDATE</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';
import {mapActions, mapGetters} from 'vuex';

export default {
    name: 'SuperadminCustomerEdit',
    data() {
        return {
            markers: [
                {
                    position: {
                        lat: null,
                        lng: null
                    }
                }
            ],
            roles: ['reseller', 'customer', 'distributor'],
            loading: true,
            distributors: [],
            form: {
                fname: '',
                lname: '',
                email: '',
                company: '',
                address: '',
                website: '',
                has_website: 0,
                complex_building_unit: '',
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                mobile: '',
                role: 'customer',
                region: '',
                distributor_id: '',
                reseller_type: '',
                tech_emails: ''
            }
        };
    },
    computed: {
        regions() {
            return Env.regions;
        },
        resellerTypes() {
            return Env.resellerTypes;
        },
        ...mapGetters({
            vg_user: 'auth/user'
        })
    },
    watch: {
        'form.has_website'() {
            if (!this.form.has_website) {
                this.form.website = '';
            }
        }
    },
    async mounted() {
        this.fetchUserDetail();
    },
    methods: {
        /**
         * autocomplete set
         */
        setPlace: async function (addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            // console.log(addressData.formatted_address)
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
            this.markers[0].position.lat = parseFloat(lat);
            this.markers[0].position.lng = parseFloat(lng);
        },

        resetPlace: function () {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        },
        /**
         * Fetch user detail
         */
        fetchUserDetail() {
            const self = this;
            this.loading = true;
            const url = `${Env.baseUrl}/superadmin/users/show/${this.$route.params.id}`;
            AuthApis.getApi(url)
                .then((res) => {
                    // Assign value
                    if (res.data.payload.role == 'reseller') {
                        this.fetchDistributors();
                    }
                    for (let key in this.form) {
                        if (
                            key == 'addressDetail' &&
                            !_.isEmpty(res.data.payload.user_metas) &&
                            res.data.payload.user_metas.lat &&
                            res.data.payload.user_metas.lng
                        ) {
                            this.form[key] = {
                                province:
                                    res.data.payload.user_metas && res.data.payload.user_metas.province ? res.data.payload.user_metas.province : '',
                                city: res.data.payload.user_metas && res.data.payload.user_metas.city ? res.data.payload.user_metas.city : '',
                                suburb: res.data.payload.user_metas && res.data.payload.user_metas.suburb ? res.data.payload.user_metas.suburb : '',
                                postcode:
                                    res.data.payload.user_metas && res.data.payload.user_metas.postcode ? res.data.payload.user_metas.postcode : '',
                                lat: res.data.payload.user_metas && res.data.payload.user_metas.lat ? res.data.payload.user_metas.lat : '',
                                lng: res.data.payload.user_metas && res.data.payload.user_metas.lng ? res.data.payload.user_metas.lng : ''
                            };
                            this.markers[0].position.lat = parseFloat(res.data.payload.user_metas.lat);
                            this.markers[0].position.lng = parseFloat(res.data.payload.user_metas.lng);
                        } else {
                            this.form[key] = res.data.payload[key];
                            this.form.website =
                                res.data.payload.user_metas && res.data.payload.user_metas.website ? res.data.payload.user_metas.website : '';
                            this.form.has_website =
                                res.data.payload.user_metas && res.data.payload.user_metas.website ? res.data.payload.user_metas.has_website : 0;
                            this.form.complex_building_unit =
                                res.data.payload.user_metas && res.data.payload.user_metas.complex_building_unit
                                    ? res.data.payload.user_metas.complex_building_unit
                                    : '';
                        }

                        if (res.data.payload.role == 'distributor') {
                            this.form.tech_emails =
                                res.data.payload.user_metas && res.data.payload.user_metas.tech_emails ? res.data.payload.user_metas.tech_emails : '';
                        }

                        if (res.data.payload.role == 'reseller') {
                            this.form.reseller_type =
                                res.data.payload.user_metas && res.data.payload.user_metas.reseller_type
                                    ? res.data.payload.user_metas.reseller_type
                                    : '';
                        }
                    }
                    this.loading = false;

                    this.$nextTick(() => {
                        if (document.getElementById('user_address_edit')) {
                            document.getElementById('user_address_edit').value = self.form.address;
                        }
                    });
                })
                .catch((err) => {
                    this.loading = false;
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                    this.$router.push({name: 'SuperadminCustomers'});
                });
        },

        async updateSuperadminCustomer() {
            this.spinner(true);
            const url = `${Env.baseUrl}/superadmin/users/update/${this.$route.params.id}`;
            AuthApis.postApi(url, this.form)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                    //this.$router.push({ name: 'SuperadminCustomers'})
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        },

        back() {
            if (this.$route.query.redirect) {
                this.$router.push({
                    name: this.$route.query.redirect,
                    query: {
                        usertype: this.$route.query.userType,
                        currentpage: this.$route.query.page,
                        s: this.$route.query.s,
                        ticket: this.$route.query.ticket
                    }
                });
            } else {
                this.$router.push({name: 'SuperadminCustomers'});
            }
        },

        fetchDistributors() {
            // this is free route
            const url = `${Env.baseUrl}/get-distributors`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.distributors = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
};
</script>
